<div class="dialog-container" [class.view-mode]="isView">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ title }}</h2>
        <button mat-icon-button (click)="cancel()" class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">
        <form [formGroup]="form" (ngSubmit)="save()" class="context-form">
            <div class="form-row" *ngIf="!isEdit && !isView && !isContextFixed">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Context</mat-label>
                    <mat-select formControlName="context" required>
                        <mat-option *ngFor="let opt of contextOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('context')?.hasError('required')">Context is required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ nameLabel }}</mat-label>
                    <input matInput formControlName="name" placeholder="Name" required>
                    <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description" rows="3"
                        placeholder="Enter description"></textarea>
                </mat-form-field>
            </div>

            <!-- <div class="form-row toggle-row">
                <mat-slide-toggle formControlName="isActive" color="primary">
                    {{ form.get('isActive')?.value ? 'Active' : 'Inactive' }}
                </mat-slide-toggle>
            </div> -->
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-footer">
        <button mat-button (click)="cancel()" [disabled]="isLoading">{{ isView ? 'Close' : 'Cancel' }}</button>
        <button *ngIf="!isView" mat-flat-button color="primary" (click)="save()" [disabled]="isLoading || form.invalid">
            <mat-icon *ngIf="!isLoading">save</mat-icon>
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span style="margin-left: 8px;">{{ isEdit ? 'Update' : 'Save' }}</span>
        </button>
    </mat-dialog-actions>
</div>
